import { feedEntryType } from 'shared/constants.json';

export default {
  computed: {
    isTask() {
      return [feedEntryType.survey, feedEntryType.updateNotification, feedEntryType.dataSourceUnhealthy, feedEntryType.dataSourceDead, feedEntryType.dataSourceQueryError].includes(this.feedEntry.type);
    },
    isSurvey() {
      return [feedEntryType.survey].includes(this.feedEntry.type);
    },
    isUpdateNotification() {
      return [feedEntryType.updateNotification].includes(this.feedEntry.type);
    },
    isIntegration() {
      return [feedEntryType.dataSourceUnhealthy, feedEntryType.dataSourceDead, feedEntryType.dataSourceQueryError].includes(this.feedEntry.type);
    },
  },
};
